import Reveal from "@/components/Reveal";
import SectionTag from "@/components/SectionTag";

const AUDIENCES = [
  { number: "01", label: "Working Adults", note: "Appointments after the workday ends" },
  { number: "02", label: "Parents & Families", note: "Care without pulling kids from school" },
  { number: "03", label: "Shift Workers", note: "Hours that work when you do" },
  { number: "04", label: "First Responders", note: "Flexible care for demanding schedules" },
];

export default function Convenience() {
  return (
    <section data-testid="convenience-section" className="bg-white">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-20 sm:px-6 md:py-28 lg:grid-cols-12 lg:gap-8 lg:px-12">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionTag number="01" label="The Advantage Difference" />
            <h2 className="mt-5 font-display text-2xl font-bold tracking-tight text-brand-navy sm:text-3xl lg:text-4xl">
              Care When Your{" "}
              <span className="font-serif italic text-brand-red">Schedule Allows</span>
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
              Most clinics close before the workday ends. Advantage Primary
              Health was built for people who cannot always make a traditional
              weekday appointment—working adults, parents, families, shift
              workers, and anyone who wants attentive primary care on evenings
              or weekends.
            </p>
            <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
              With appointments available Wednesday through Sunday until 8:00
              PM, you can see a provider who takes time to listen—without
              rearranging your entire life.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <div className="grid gap-5 sm:grid-cols-2">
            {AUDIENCES.map((a, i) => (
              <Reveal key={a.number} delay={i * 0.08}>
                <div
                  data-testid={`audience-card-${a.number}`}
                  className="group h-full rounded-3xl border border-slate-100 bg-slate-50/60 p-7 transition-[background-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-soft"
                >
                  <span className="font-mono text-xs tracking-[0.3em] text-brand-red">
                    {a.number}
                  </span>
                  <h3 className="mt-3 font-display text-lg font-semibold text-brand-navy">
                    {a.label}
                  </h3>
                  <p className="mt-1.5 text-sm text-slate-500">{a.note}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
